<template>
  <EventResultLive v-if="isEventLive" />
  <EventResult v-else />
</template>


<script>
import EventResult from './EventResult.vue'
import EventResultLive from './EventResultLive.vue'

export default {
  name: "EventResultIndex",
  components: {
    EventResult,
    EventResultLive
  },
  computed: {
    isEventLive() {
      return (this.$route.query.isLive == 1 || this.$route.query.isLive == 'true') ? true : false
    }
  }
}
</script>